import { compareDates } from '@/common/functions/compareDates';
import { copyLinkToClipboard } from '@/common/functions/copyLinkToClipboard';
import {
	navigateToContact,
	navigateToOrder,
	navigateToUser,
} from '@/common/functions/naviagte';
import moment from 'moment';
import { IconWrapper } from '../ContactsRoadTable.styled';
import Icon from '@/common/components/Icon';

export const getRaws = (data) =>
	data
		.sort((a, b) =>
			compareDates(new Date(b.created_at), new Date(a.created_at)),
		)
		.map((element, i) => (
			<tr key={i}>
				<td>{i + 1}</td>
				<td>{moment(element.created_at).format('DD/MM/YYYY HH:mm:ss')}</td>
				<td>
					{(element.updated_at &&
						moment(element.updated_at).format('DD/MM/YYYY HH:mm:ss')) ||
						'-----'}
				</td>
				<td>{element.consultant.username}</td>
				<td>{element.status || '------'}</td>
				<td>{element.contact.email || '------'}</td>
				<td>{element.contact.phone_number || '------'}</td>
				<td>{element.contact.full_name || '------'}</td>
				<td>
					<IconWrapper>
						<Icon
							name='user'
							className='animation-scale'
							style={{ cursor: 'pointer' }}
							onClick={() => navigateToUser(element.consultant._id)}
						/>
						<Icon
							name='address-book'
							className='animation-scale'
							style={{ cursor: 'pointer' }}
							onClick={() => navigateToOrder(element.order._id)}
						/>
						<Icon
							name='book'
							className='animation-scale'
							style={{ cursor: 'pointer' }}
							onClick={() => navigateToContact(element.contact._id)}
						/>
						<Icon
							name='copy'
							className='animation-scale'
							style={{ cursor: 'pointer' }}
							onClick={() => copyLinkToClipboard(element._id)}
						/>
					</IconWrapper>
				</td>
			</tr>
		));
